"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_RESPONSE_STATUS_CODE = exports.ExtendedAxiosError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
/**
 * Represents a status code of `0` to indicate that no response was received from the server.
 *
 * @remarks
 * This constant is used in scenarios where the HTTP request did not reach the server or the server
 * did not provide a valid response, such as when the network is unavailable, the request times out,
 * or there's a CORS error. Since `0` is not a valid HTTP status code, it serves as a special
 * placeholder to signal the absence of any server response.
 */
const NO_RESPONSE_STATUS_CODE = exports.NO_RESPONSE_STATUS_CODE = 0;

/**
 * This formats AxiosError into more readable object not only for user but also for Application Insights
 */
class ExtendedAxiosError extends Error {
  constructor(axiosError) {
    super(axiosError.message.startsWith('Axios Error: ') ? axiosError.message : `Axios Error: ${axiosError.message}`);
    (0, _defineProperty2.default)(this, "baseUrl", void 0);
    (0, _defineProperty2.default)(this, "pathname", void 0);
    (0, _defineProperty2.default)(this, "method", void 0);
    (0, _defineProperty2.default)(this, "statusCode", void 0);
    (0, _defineProperty2.default)(this, "statusText", void 0);
    (0, _defineProperty2.default)(this, "responseBody", null);
    (0, _defineProperty2.default)(this, "callstack", void 0);
    this.name = 'ExtendedAxiosError';
    const {
      response,
      stack,
      code,
      config,
      status
    } = axiosError;
    // Response could be undefined on timeout for example
    this.baseUrl = response?.config.baseURL ?? config?.baseURL ?? null;
    this.pathname = response?.config.url ?? config?.url ?? null;
    this.method = (response?.config.method ?? config?.method)?.toUpperCase() ?? null;
    this.statusCode = response?.status ?? status ?? NO_RESPONSE_STATUS_CODE;
    this.statusText = response?.statusText ?? code ?? null;

    // No need to pass body on 404 and empty body
    if (this.statusCode !== 404 && response?.data != null) {
      this.responseBody = response.data;
    }
    this.callstack = stack ?? null;
  }
}
exports.ExtendedAxiosError = ExtendedAxiosError;
